import { render, staticRenderFns } from "./accountBindCode.vue?vue&type=template&id=05b0441e&scoped=true"
import script from "./accountBindCode.vue?vue&type=script&lang=js"
export * from "./accountBindCode.vue?vue&type=script&lang=js"
import style0 from "./accountBindCode.vue?vue&type=style&index=0&id=05b0441e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b0441e",
  null
  
)

export default component.exports